<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-cloud.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0">雲原生產品</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">雲原生產品</h2>
				<div style="margin-top: 48px; ">
					<p style="font-size: 18px">
						通過一個生產模型，一套數據平台，一套流程機制，幫助企業將生產運營單元無縫整合至雲端，實現跨地域的高效協同。建立基於行業互聯網協同研發的支撐環境和生態系統，以複雜系統研製體系為核心牽引，以基於模型的系統工程為基本方法，以構型管理為關鍵主線，以智能製造為主要實現手段，面向多領域提供複雜系統研發完整解決方案，實現知識和資源共享，避免重複投資，提高研發效能，提升研發能力水平，實現各組織間協同研發。
					</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心功能</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">異地協同研發</div>
										<div class="t2">
											整合系統、硬件、軟件、結構、工藝、光學、可靠性、安全性、測試性、維護性等設計過程工具鏈，通過靈活介入實現異地協同研發
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">複雜系統項目運行平台</div>
										<div class="t2">
											實現項目管理、產品數據管理、供應商管理、規範管理、研製流程管理的整合，為數據管理提供統一傳輸接口，為產品研發提供先進理念和模式
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">前沿技術研發平台</div>
										<div class="t2">
											保護知識產權，實現研製數據資源共享，同時整合先進技術研發產學研資源，建設系統虛擬集成與仿真驗證環境、模型庫，實現先進技術原型孵化與仿真驗證
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/cloud1-1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">優勢價值</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/cloud1-2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">業務數字化</div>
										<div class="t2">
											通過數據治理、數據挖掘和大數據分析，提升研發、製造、測試等環節的工作質量，減少試錯成本，提高產品品質
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">業務雲化</div>
										<div class="t2">
											提供一致性研製環境，符合法律法規要求，固化企業所需的流程和體系設計，使系統設計、製造、仿真等業務得以高效開展，降本增效
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">業務智能化</div>
										<div class="t2">
											以數據為驅動，整合場景、算法、算力，拓展平台認知邊界，實現流程自動化和應用智能化，推動業務智能化轉型
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
